export class FixedPhraseReference {
  constructor(
    public name: string,
    public text: string) {
  }

  clone() {
    return new FixedPhraseReference(
      this.name,
      this.text,
    );
  }
}
